import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
} from "react-bootstrap";
import "react-phone-input-2/lib/style.css";
import { useGetEsmeListMutation } from "Services/services";
// import hasPermission from "pages/Permissions";

export default () => {
  const [tableData, setTableData] = useState([]);
  // const [debouncedValue, setDebouncedValue] = useState("");

  // const [searchValue, setSearchValue] = useState("");


  // Debounce search value
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     setDebouncedValue(searchValue); // Set debounced value after 3 seconds
  //   }, 2000);
  //   // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
  //   return () => {
  //     clearTimeout(handler);
  //   };
  // }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, []);

  const [getList] = useGetEsmeListMutation();
  const fetchTableData = () => {
    getList()
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.esme_monitoring || []);
          // setTotalPosts(response?.data?.data.totalPosts || 0)
          // setTotalPages(response?.data?.data.totalPages || 0)
        } else {
          setTableData([]);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        console.error("Error fetching user data", error);
      });
  };

  // const changeSearchValue = (e) => {
  //   const newSearchValue = e.target.value;
  //   setSearchValue(newSearchValue);
  // };

  // const handlePageChange = (pageNumber) => {
  //     setCurrentPage(pageNumber);
  // };

  // const handlePrev = () => {
  //     if (currentPage > 1) {
  //         setCurrentPage(currentPage - 1);
  //     }
  // };

  // const handleNext = () => {
  //     if (currentPage < totalPages) {
  //         setCurrentPage(currentPage + 1);
  //     }
  // };

  const TableRow = (props) => {
    return (
      <tr className="border-bottom">
        <td>
          <span className="fw-normal" title={props.system_id||'-'}>{props.system_id || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.bind_count||'-'}>{props.bind_count || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.max_binds||'-'}>{props.max_binds || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.inbound_load||'-'}>{props.inbound_load || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.max_inbound_load||'-'}>{props.max_inbound_load || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.outbound_load||'-'}>{props.outbound_load || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.mt||'-'}>{props.mt || "-"}</span>
        </td>
        <td>
          <span className="fw-normal"> title={props.mo||'-'} {props.mo || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.dlr||'-'}>{props.dlr || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.errors||'-'}>{props.errors || "-"}</span>
        </td>
      </tr>
    );
  };

  // const canDownload = hasPermission("ESME List", "download");

  return (
    <>
      <Card border={1}>
        {/* <div className="d-flex flex-wrap align-items-center gap-2">
          <InputGroup className="mb-3 fmxw-300">
            <InputGroup.Text>
              <SearchIcon className="icon icon-xs" />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder="Search System ID"
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>

          <div className="ms-auto d-flex mb-3">
            {canDownload && (
              <Button variant="outline-gray-300" className="p-2">
                <DownloadIcon className="icon icon-sm" />
              </Button>
            )}

            <ButtonGroup className="">
                            <Dropdown>
                                <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-1">
                                    <CogIcon className="icon icon-sm" />
                                    <span className="visually-hidden">Toggle Dropdown</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
                                    <span className="small ps-3 fw-bold text-dark">Show</span>
                                    {[10, 20, 30].map((limit) => (
                                        <Dropdown.Item
                                            key={limit}
                                            className={`d-flex align-items-center fw-bold ${limit === 30 ? 'rounded-bottom' : ''}`}
                                            onClick={() => {
                                                setPagelimit(limit); // Update the page limit
                                                setCurrentPage(1);  // Reset the page number to 1
                                            }}
                                        >
                                            {limit} {pagelimit === limit && <CheckIcon className="icon icon-xxs ms-auto" />}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
          </div>
        </div> */}

        <div className="custom-scroll-wrapper">
          <div className="scroll-container">
            <Table
              responsive
              className="align-items-center table-flush table-outlines"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-bottom">System ID</th>
                  <th className="border-bottom">Bind Count</th>
                  <th className="border-bottom">Max Binds</th>
                  <th className="border-bottom">Inbound Load</th>
                  <th className="border-bottom">Max Inbound Load</th>
                  <th className="border-bottom">Outbound Load</th>
                  <th className="border-bottom">MT</th>
                  <th className="border-bottom">MO</th>
                  <th className="border-bottom">DLR</th>
                  <th className="border-bottom">Errors</th>
                </tr>
              </thead>
              <tbody className="border-0">
                {tableData.length > 0 ? (
                  tableData.map((u, index) => <TableRow key={index} {...u} />)
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center text-danger">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        {/* <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                                <Nav>
                                    <Pagination className="mb-0">
                                        <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
                                            Previous
                                        </Pagination.Prev>
                                        {currentPage >= 3 && (
                                            <>
                                                <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                                                <Pagination.Ellipsis />
                                            </>
                                        )}
                                        {currentPage > 1 && (
                                            <Pagination.Item onClick={() => handlePageChange(currentPage - 1)}>
                                                {currentPage - 1}
                                            </Pagination.Item>
                                        )}
                                        <Pagination.Item active>{currentPage}</Pagination.Item>
                                        {currentPage < totalPages && (
                                            <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>
                                                {currentPage + 1}
                                            </Pagination.Item>
                                        )}
                                        {currentPage < totalPages - 1 && (
                                            <>
                                                <Pagination.Ellipsis />
                                                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                                                    {totalPages}
                                                </Pagination.Item>
                                            </>
                                        )}
                                        <Pagination.Next onClick={handleNext} disabled={currentPage === totalPages}>
                                            Next
                                        </Pagination.Next>
                                    </Pagination>
                                </Nav>
                                <small className="fw-normal small mt-2 mt-md-0">
                                    Showing 1 to <b>{pagelimit}</b> of <b>{totalPosts}</b> entries.
                                </small>
                            </Card.Footer> */}
      </Card>
    </>
  );
};
